import MemberData from './MemberData'

export default MemberData
